import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/Card';
import { Percent, TrendingUp, CalendarClock, Tags } from 'lucide-react';
import { OfferType } from '../../types';
import { cn } from '../../lib/utils';
interface OfferTypeSelectorProps {
  onSelect: (type: OfferType) => void;
}
export function OfferTypeSelector({
  onSelect
}: OfferTypeSelectorProps) {
  const types = [{
    id: 'fixed' as OfferType,
    title: 'Fixed Cashback %',
    description: 'Simple flat rate for all purchases. E.g. "8% cashback on everything".',
    icon: Percent,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: 'tiered' as OfferType,
    title: 'Tiered Cashback',
    description: 'Incentivize larger purchases. E.g. "Spend $150+, get 10% back".',
    icon: TrendingUp,
    color: 'bg-green-100 text-green-600'
  }, {
    id: 'promotional' as OfferType,
    title: 'Time-Limited Promo',
    description: 'Boost sales during specific dates. E.g. "15% cashback for 2 weeks".',
    icon: CalendarClock,
    color: 'bg-purple-100 text-purple-600'
  }, {
    id: 'category' as OfferType,
    title: 'Category-Specific',
    description: 'Different rates for different items. E.g. "8% on Service, 5% on Products".',
    icon: Tags,
    color: 'bg-orange-100 text-orange-600'
  }];
  return <div className="grid gap-6 md:grid-cols-2" data-id="element-121">
      {types.map(type => <Card key={type.id} className="cursor-pointer hover:border-[#218080] hover:shadow-md transition-all group" onClick={() => onSelect(type.id)} data-id="element-122">
          <CardHeader className="flex flex-row items-center gap-4 pb-2" data-id="element-123">
            <div className={cn('p-3 rounded-lg transition-colors group-hover:bg-[#218080] group-hover:text-white', type.color)} data-id="element-124">
              <type.icon className="h-6 w-6" data-id="element-125" />
            </div>
            <div data-id="element-126">
              <CardTitle className="text-lg" data-id="element-127">{type.title}</CardTitle>
            </div>
          </CardHeader>
          <CardContent data-id="element-128">
            <CardDescription className="text-sm text-slate-500" data-id="element-129">
              {type.description}
            </CardDescription>
          </CardContent>
        </Card>)}
    </div>;
}